import { interpolate } from 'react-native-reanimated';
import { Breakpoint } from '../../hooks/useBreakpoint/index.types';
import { ModalConfig } from './Modal.types';

const MOBILE_MODAL_CONFIG: ModalConfig = {
  width: '100%',
  height: '100%',
  getAnimatedStyle: (animatedValue) => ({
    transform: [
      { translateY: `${interpolate(animatedValue.value, [0, 1], [100, 0])}%` },
    ],
  }),
};

const DESKTOP_MODAL_CONFIG: ModalConfig = {
  minWidth: 375,
  maxWidth: '75%',
  maxHeight: '90%',
  overflow: 'hidden',
  borderRadius: 'radius-400',
  getAnimatedStyle: (animatedValue) => ({
    opacity: animatedValue.value,
    transform: [{ scale: animatedValue.value }],
  }),
};

export const MODAL_CONFIG = {
  [Breakpoint.MOBILE]: MOBILE_MODAL_CONFIG,
  [Breakpoint.TABLET]: DESKTOP_MODAL_CONFIG,
  [Breakpoint.DESKTOP]: DESKTOP_MODAL_CONFIG,
};
